import { MutedOutlined, SoundOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import cn from 'classnames';
import { useCallback, useState } from 'react';

import { useCloseFloatingOnScroll } from '@app/shared/components';

import type { FC } from 'react';

import './SoundToggleButton.scss';

interface SoundToggleButtonProps {
  isSoundEnabled: boolean;
  onToggleSound(): void;
  className?: string;
  disabled?: boolean;
}

export const SoundToggleButton: FC<SoundToggleButtonProps> = ({
  className,
  disabled = false,
  isSoundEnabled,
  onToggleSound,
}) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const closeTooltipHandler = useCallback(() => setIsTooltipOpen(false), []);

  useCloseFloatingOnScroll(isTooltipOpen, closeTooltipHandler);

  const tooltipTitle = `Звук ${isSoundEnabled ? 'включён' : 'выключен'}`;
  const ariaLabel = `${
    isSoundEnabled ? 'Отключить' : 'Включить'
  } звук входящих сообщений`;

  const SoundIcon = isSoundEnabled ? SoundOutlined : MutedOutlined;

  return (
    <Tooltip
      title={tooltipTitle}
      open={isTooltipOpen}
      destroyOnHidden
      onOpenChange={setIsTooltipOpen}
    >
      <Button
        aria-label={ariaLabel}
        aria-pressed={isSoundEnabled}
        className={cn(
          'SoundToggleButton',
          {
            'SoundToggleButton--enabled': isSoundEnabled,
            'SoundToggleButton--muted': !isSoundEnabled,
          },
          className
        )}
        disabled={disabled}
        htmlType="button"
        icon={<SoundIcon />}
        type={isSoundEnabled ? 'primary' : 'default'}
        onClick={onToggleSound}
      />
    </Tooltip>
  );
};
